import {
    fileshubRecentFilesFREHeader,
    fileshubRecentFilesFREBody,
} from './RecentFilesFRECallout.locstring.json';
import { fileshubFREGotIt } from '../../strings.locstring.json';
import loc from 'owa-localize';
import { CalloutTarget, setCalloutShown, shouldShowRecentCallout } from 'owa-group-files-hub-store';
import { lighted, LightningId } from 'owa-lightning-v2';

import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { IButtonProps, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface RecentFilesCalloutProps {
    lid: LightningId;
    target: () => HTMLElement;
}

@observer
export class RecentFilesFRECallout extends React.Component<RecentFilesCalloutProps, {}> {
    render() {
        let gotItButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: loc(fileshubFREGotIt),
            onClick: this.onClose,
        };

        return (
            shouldShowRecentCallout() && (
                <TeachingBubble
                    calloutProps={{
                        beakWidth: 12,
                        directionalHint: DirectionalHint.rightTopEdge,
                    }}
                    targetElement={this.props.target()}
                    hasCloseIcon={true}
                    onDismiss={this.onClose}
                    hasSmallHeadline={true}
                    headline={loc(fileshubRecentFilesFREHeader)}
                    primaryButtonProps={gotItButtonProps}>
                    {loc(fileshubRecentFilesFREBody)}
                </TeachingBubble>
            )
        );
    }

    private onClose = () => {
        setCalloutShown(CalloutTarget.RecentFiles);
        lighted(this.props.lid);
    };
}
